import { lazy, Suspense } from "react";

const CaptainPanelTrigger = lazy(async () => {
  const module = await import("@/modules/captain/components/panel/CaptainPanelTrigger");
  return { default: module.CaptainPanelTrigger };
});

export const LazyCaptainPanelTrigger = () => {
  return (
    <Suspense fallback={null}>
      <CaptainPanelTrigger />
    </Suspense>
  );
};
